import { EnvTypeConfig } from './env-type-config';

export const environment = {
  production: false,
  env: EnvTypeConfig.dev.env //available environments dev, cert, prod
};